import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import style from "./style.module.scss";
export default function RadioButtonGroup(props) {
    const { children, title, layout = "vertical" } = props;
    const layoutClass = "radio-button-group__" + layout;
    return (_jsxs("div", { className: (style["radio-button-group"], style[layoutClass]), children: [title ? _jsx("div", { className: style["radio-button-group__title"], children: title }) : null, _jsx("div", { className: style["radio-button-group__options"], children: children })] }));
}
